import React, { useEffect, useState } from 'react';

const useHandleScroll = (ref: React.RefObject<HTMLElement | null>) => {
  const [isTablet, setIsTablet] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const resizeListener = () => {
    setIsTablet(window.innerWidth <= 1679);
  };
  useEffect(() => {
    // ref가 유효한 경우에만 이벤트 리스너를 등록
    const currentRef = (ref as React.RefObject<HTMLDivElement | null>).current;

    const handleShowButton = () => {
      if (currentRef && currentRef.scrollTop > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    if (currentRef) {
      currentRef.addEventListener('scroll', handleShowButton);
    }
    window.addEventListener('resize', resizeListener);

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleShowButton);
      }
      window.removeEventListener('resize', resizeListener);
    };
  }, [ref]);

  const scrollToTop = () => {
    ref.current?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    resizeListener();
  }, []);

  return { isTablet, showButton, scrollToTop };
};
export default useHandleScroll;
